import type { ReactNode } from "react";
import { HomeThread } from "@/features/intelligence/home/components/HomeThread";
import { SimonBarInput } from "@/features/intelligence/components/SimonBarInput";
import type { ChatSurfaceApi } from "@/features/intelligence/hooks/use-chat-surface";

export function SimonConversationView({
  surface,
  onSubmitText,
  homeGreeting,
  homeSlot,
  threadTop,
  homeFooterFade = false,
}: {
  surface: ChatSurfaceApi;
  onSubmitText: (text: string) => void;
  homeGreeting?: ReactNode;
  homeSlot?: ReactNode;
  threadTop?: ReactNode;
  homeFooterFade?: boolean;
}) {
  const greeting = homeGreeting !== undefined;

  return (
    <>
      <div className="relative flex min-h-0 flex-1 flex-col">
        {homeSlot !== undefined ? (
          <div className="min-h-0 flex-1 overflow-y-auto pb-[140px]">{homeSlot}</div>
        ) : greeting ? (
          <div className="min-h-0 flex-1 overflow-y-auto px-[24px] pt-[20vh]">
            <div className="mx-auto w-full max-w-[760px] shrink-0">{homeGreeting}</div>
          </div>
        ) : (
          <>
            {threadTop != null && (
              <div
                data-thread-top
                className="mx-auto flex w-full max-w-[760px] shrink-0 items-center px-[22px] pt-[8px]"
              >
                {threadTop}
              </div>
            )}
            <div className="flex min-h-0 flex-1">
              <HomeThread surface={surface} />
            </div>
          </>
        )}

        <div
          data-composer
          className={
            homeSlot !== undefined
              ? "absolute inset-x-0 bottom-0 z-20 mx-auto w-full max-w-[648px] px-[24px] py-[12px]"
              : "relative z-20 mx-auto w-full max-w-[648px] shrink-0 px-[24px] py-[12px]"
          }
        >
          <SimonBarInput
            sendLocked={surface.busy}
            onSubmitText={onSubmitText}
            attachments={surface.attachments}
            onAttach={(file) => void surface.attach(file)}
            onRemoveAttachment={surface.removeAttachment}
            onStop={() => void surface.stop()}
          />
        </div>
      </div>
      {homeFooterFade && (
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-[96px]"
          style={{ background: "var(--gradient-footer-fade)" }}
        />
      )}
    </>
  );
}
